import { brand } from '@/styles/shared';
interface LoadingSpinnerIconProps {
  width?: number;
  height?: number;
  stroke?: string;
  strokeWidth?: string;
}

const LoadingSpinnerIcon = ({ 
  width = 52, 
  height = 52, 
  stroke = brand.purpleAccent,
  strokeWidth = "4.22619"
}: LoadingSpinnerIconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 52 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25.9998 47.1309C37.6705 47.1309 47.1308 37.6706 47.1308 26C47.1308 14.3293 37.6705 4.86902 25.9998 4.86902C14.3292 4.86902 4.8689 14.3293 4.8689 26"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default LoadingSpinnerIcon;
